export default __webpack_public_path__ + "static/media/coreCard1.d784cf5a.svg";